import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=3337da20&scoped=true&"
import script from "./pending.vue?vue&type=script&setup=true&lang=js&"
export * from "./pending.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./pending.vue?vue&type=style&index=0&id=3337da20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3337da20",
  null
  
)

export default component.exports